import { useCurrentUser } from '@qualio/ui-components';
import { useQueryClient } from 'react-query';
import { invalidateAllDocumentsTableData } from '../Tabs/AllDocuments/AllDocumentsTable';
import { invalidateYourActionsTableData } from '../Tabs/YourActions/YourActionsTable';
import { invalidateYourDocumentsTableData } from '../Tabs/YourDocuments/YourDocumentsTable';
import { WorkspaceTabs } from '../WorkspaceV2';

export const useTableDataInvalidation = () => {
  const queryClient = useQueryClient();
  const { companyId } = useCurrentUser();

  const invalidate = async (tab: WorkspaceTabs) => {
    switch (tab) {
      case WorkspaceTabs.YOUR_DOCUMENTS:
        await invalidateYourDocumentsTableData(queryClient, companyId);
        break;
      case WorkspaceTabs.YOUR_ACTIONS:
        await invalidateYourActionsTableData(queryClient, companyId);
        break;
      case WorkspaceTabs.ALL_DOCUMENTS:
        await invalidateAllDocumentsTableData(queryClient, companyId);
        break;
    }
  };

  return { invalidate };
};
